import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import baseURl from './setBaseUrl'

axios.defaults.baseURL = baseURl
axios.defaults.withCredentials = false

Vue.use(VueAxios, axios)

